import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Convert a backend-relative upload path ("/uploads/..") into an absolute URL */
export const fileUrl = (p) => {
    if (!p) return "";
    if (p.startsWith("http") || p.startsWith("data:")) return p;
    return `${BACKEND_URL}${p}`;
};

export const api = axios.create({ baseURL: API });

export const ADMIN_TOKEN_KEY = "mc_admin_token";

export const getAdminToken = () =>
    typeof window !== "undefined"
        ? window.localStorage.getItem(ADMIN_TOKEN_KEY) || ""
        : "";

export const setAdminToken = (t) => {
    if (t) window.localStorage.setItem(ADMIN_TOKEN_KEY, t);
    else window.localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const adminHeaders = () => ({ "x-admin-token": getAdminToken() });
